import {ActivatedRoute, CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';

import {AuthService} from '../../auth.service';
import {AccountService} from '../../ecv-http-services/services/account.service';




@Injectable()
export class CrmTokenAuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private accountService: AccountService) {
  }

  canActivate() {
    this.route.queryParams.subscribe(params => {
      const crmToken = params['crm_id'];
      const destination = params['destination'];

      if (crmToken && destination) {
        this.authService.logInWithCrmToken(crmToken)
          .subscribe(JWT => {
            this.authService.sessionService.clear();
            this.authService.sessionService.setJWT(JWT);
            this.accountService.getPersonalDetails().subscribe(response => {
              localStorage.setItem('userFirstName', response.firstName);
              localStorage.setItem('userLastName', response.lastName);
            });
            this.router.navigate([destination]);
          });
      }
    });
    return true;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/guards/services/crm-token-auth-guard.service.ts